export const formatZipCode = (value) => {
  const digitsOnly = value.replace(/\D/g, '');
  if (digitsOnly.length > 5) {
    return digitsOnly.slice(0, 5) + '-' + digitsOnly.slice(5, 9);
  }
  
  return digitsOnly;
};

export const formatPhoneNumber = (value) => {
  if (!value) return '';
  const digitsOnly = value.replace(/\D/g, '');
  if (digitsOnly.length === 10) {
    return `(${digitsOnly.slice(0, 3)}) ${digitsOnly.slice(3, 6)}-${digitsOnly.slice(6)}`;
  } else if (digitsOnly.length === 11 && digitsOnly.startsWith('1')) {
    return `+1 (${digitsOnly.slice(1, 4)}) ${digitsOnly.slice(4, 7)}-${digitsOnly.slice(7)}`;
  }

  return value;
};